import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { getToken } from '@/utils/auth' // 验权
import { Message } from 'element-ui'

const whiteList = ['/login', '/register', '/verify-successfully', '/forgot-password'] // 不重定向白名单

const whiteListName = ['OpenShopSettle']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    }
    if (store.getters.roles.length !== 0) {
      next()
    }
    Promise.all([store.dispatch('GetInfo'), store.dispatch('SetShopBasic'), store.dispatch('SetOpenShopInfo'), store.dispatch('SetOpenShopStepInfo')])
      .then(res => {
        if (store.state.shop.open_shop_first) {
          next({ path: '/open-shop' })
        } else {
          next()
        }
      })
      .catch(error => {
        console.log(error)
        store.dispatch('FedLogOut').then(() => {
          Message.error('验证失败,请重新登录')
          next({ path: '/login' })
        })
      })
  } else {
    if (whiteList.indexOf(to.path) !== -1 || whiteListName.indexOf(to.name) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
